import { c as _c } from "react/compiler-runtime";
import { JSX, SVGProps } from "react";
export function AtlasIconLogo(args) {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M 626 180 L 294 891 L 716 605 L 1044 1130 L 800 552 L 503 672 L 626 412 L 706 572 L 792 534 Z" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== args) {
    t1 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1254 1254" {...args}>{t0}</svg>;
    $[1] = args;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}